// Tiny GTM dataLayer wrapper. All app events flow through `track()`.
// Configure matching GA4 events inside GTM by adding a "GA4 Event" tag
// triggered by a "Custom Event" matching the event name.

export function track(event, params = {}) {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
}

// Common helpers — keep payload shapes consistent across the app.
export const trackCalculatorUsed = (p) =>
    track("calculator_used", {
        seller_country: p.seller,
        buyer_country: p.buyer,
        category: p.category,
        net_price: p.net,
        rate: p.rate,
        gross: p.gross,
    });

export const trackCountryPair = (seller, buyer) =>
    track("country_pair_selected", { seller_country: seller, buyer_country: buyer });

export const trackOssThresholdAbove = (home, sales) =>
    track("oss_threshold_above", { home_country: home, sales_total: sales });

export const trackViesValidated = (country, vat, valid) =>
    track("vies_validated", { vat_country: country, vat_number: vat, vat_valid: valid });

export const trackExport = (format) =>
    track(format === "pdf" ? "pdf_exported" : "csv_exported", { format });

export const trackAffiliateClick = (partner, slot) =>
    track("affiliate_click", { partner, slot });

export const trackNewsletterSubscribe = () => track("newsletter_subscribe");

export const trackLangChanged = (from, to) =>
    track("lang_changed", { lang_from: from, lang_to: to });

export const trackShareLink = () => track("share_link_copied");

export const trackPopularRoute = (seller, buyer) =>
    track("popular_route_clicked", { seller_country: seller, buyer_country: buyer });

// SPA virtual pageview — fired on every route change.
export const trackPageView = (path) =>
    track("virtual_pageview", { page_path: path, page_location: typeof window !== "undefined" ? window.location.href : "" });
